import React, { useEffect, useState } from "react"
import style from "./vdp.module.scss"
import {formatNumberWithCommas} from '../currentOffers/utility/offerFunctions'

const fields = [
  { label: "Stock #: ", value: "StockNumber" },
  { label: "VIN #: ", value: "VIN" },
  { label: "Year: ", value: "Year" },
  { label: "Make: ", value: "Make" },
  { label: "Model: ", value: "Model" },
  { label: "Trim: ", value: "Trim" },
  { label: "Drive Train: ", value: "Drivetrain" },
  { label: "Body: ", value: "BodyType" },
  { label: "Doors: ", value: "DoorCount" },
  { label: "Kilometers : ", value: "Mileage" },
  { label: "City L/100 km: ", value: "CityMPG" },
  { label: "Hwy L/100 km: ", value: "HwyMPG" },
  { label: "Transmission: ", value: "Transmission" },
  { label: "Interior Color: ", value: "InteriorColor" },
  { label: "Exterior Color: ", value: "ExteriorColor" },
  { label: "Engine: ", value: "Engine" }
]

function capitalizeWords(str) {
  return str.replace(/\b\w/g, char => char.toUpperCase());
}

export default function VDPDescription({ vehicle }) {

  const { Comments } = vehicle.VehicleInfo

  return (
    <section className={style["section-wrap"]}>
      {Comments && Comments.length > 0 && (
        <div className={style["description-section"]}>
          <h2 className={style["section-title"]}>DESCRIPTION</h2>
          <div className={style["features"]}>
            <p className={style["features__description"]}>
              <span dangerouslySetInnerHTML={{ __html: Comments }} />
            </p>
          </div>
        </div>
      )}
      <div className={style["options-section"]}>
        <h2 className={style["section-title"]}>BASIC INFO</h2>
        <div className={style["option-list"]}>
          {fields.map((field, idx) => {
            const value = vehicle.VehicleInfo[field.value];
            if (!value) return null;

            return (
              <div className={style["option-list__item"]} key={idx}>
                <span className={style["option-list__option"]}>
                  {field.label}
                </span>
                <span className={style["option-list__value"]}>
                  {field.value === "Engine" ? (
                    <div className={style["option-list__value"]}>
                      {value.split(",").map((part, i) => (
                        <div key={i} className={style["option-list__line"]}>
                          {capitalizeWords(part.trim())}
                        </div>
                      ))}
                    </div>
                  ) : field.value === "Mileage" ? (
                    <span className={style["option-list__value"]}>{formatNumberWithCommas(value)}</span>
                  ) : (
                    <span className={style["option-list__value"]}>{value}</span>
                  )}

                </span>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}